import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=0d2769fa&scoped=true&"
import script from "./addConfig.vue?vue&type=script&lang=js&"
export * from "./addConfig.vue?vue&type=script&lang=js&"
import style0 from "./addConfig.vue?vue&type=style&index=0&id=0d2769fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2769fa",
  null
  
)

export default component.exports